import { render, staticRenderFns } from "./HomeAreaPais.vue?vue&type=template&id=0cf52e35&"
import script from "./HomeAreaPais.vue?vue&type=script&lang=js&"
export * from "./HomeAreaPais.vue?vue&type=script&lang=js&"
import style0 from "./HomeAreaPais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports